//  ----------      START   IMPORT  BLOCK       ----------
import React from "react";
//  Widgets
import BaseLayout from "../BaseLayout/BaseLayout";
import LoginWidget from "../../../../LoginWidget/LoginWidget";
//  Config
import "./AuthForm.css";
//  ----------      END   IMPORT  BLOCK       ----------

const AuthForm: React.FC = () => {
  return (
    <BaseLayout>
      <div className="landing-page">
        <div
          className="landing-content d-flex justify-content-center align-items-center"
          style={{ minHeight: "80vh" }}
        >
          <div style={{ width: "100%", maxWidth: "400px" }}>
            <LoginWidget />
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default AuthForm;